/* NOTIFICATION */
export const NOTIFICATION_LIST = 'NOTIFICATION_LIST';
export const NOTIFICATION_LIST_SUCCESS = 'NOTIFICATION_LIST_SUCCESS';
export const NOTIFICATION_LIST_FAILED = 'NOTIFICATION_LIST_FAILED';

